import * as React from "react";
import { useCustomerCartId, useCustomerSession } from "../../Common";

import {
  useMyBagDataSourceIntersection,
  useMyBagInitialization,
  useMyBagLoadingState,
  useMyBagPresentationModel,
} from "../providers";

export const MyBagEmptyPortal: React.FunctionComponent = (props) => {
  const { presentationMyBagItems, presentationMyBagOrder } =
    useMyBagPresentationModel();
  const { isLoading } = useMyBagLoadingState();
  const { hasInitialized } = useMyBagInitialization();
  const { mostLatestType } = useMyBagDataSourceIntersection();
  const { isCustomerLoggedIn } = useCustomerSession();
  const { cartId } = useCustomerCartId();

  const shouldPresentTheEmptyState = React.useMemo(() => {
    const eitherItHasTheOrderDetails_orThereShouldntBeAnyOrderDetails =
      presentationMyBagOrder ||
      ((!cartId || cartId.length < 1) && !isCustomerLoggedIn);
    const shouldThereBeNoneAsTheLatestType =
      mostLatestType === "none" &&
      (!cartId || cartId.length < 1) &&
      !isCustomerLoggedIn;
    return (
      hasInitialized &&
      !isLoading &&
      eitherItHasTheOrderDetails_orThereShouldntBeAnyOrderDetails &&
      (mostLatestType === "data" ||
        mostLatestType === "error" ||
        shouldThereBeNoneAsTheLatestType) &&
      presentationMyBagItems.length === 0
    );
  }, [
    hasInitialized,
    isLoading,
    mostLatestType,
    presentationMyBagItems,
    cartId,
    isCustomerLoggedIn,
    presentationMyBagOrder,
  ]);

  if (!shouldPresentTheEmptyState) {
    return null;
  }

  return <React.Fragment>{props.children || []}</React.Fragment>;
};
